// @71153 - Cadastro de Motivos
<template>
    <div id="main">
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("motivo") }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">
                                        {{ $t($route.meta.contexto) }}
                                    </a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: `${$route.meta.abrev}-motivo-list`,
                                            })
                                        "
                                        >{{ $t("motivo") }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id
                                            ? $route.params.id
                                            : $t("novo")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="redirectToPage(2)"
                        >
                            {{ $t("voltar") }}
                        </button>
                        <button
                            v-if="!cantEdit && !integracao"
                            class="save-btn"
                            type="button"
                            @click="saveMotivo()"
                            :disabled="isSaving"
                        >
                            {{ $t("salvar") }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-7">
                            <v-input
                                :id="generateId(3)"
                                ref="descricaoInput"
                                v-model="motivo.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                required
                                :title="'motivo'"
                                :msg="'msg-erro-campo-obrigatorio'"
                                uppercase
                                :invalid="!motivo.descricao"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-5">
                            <vss-select
                                :id="generateId(6)"
                                ref="origemSelected"
                                :searchable="false"
                                :options="origemSelect"
                                v-model="origemSelected"
                                title="origem"
                                :mlLabels="true"
                                required
                                placeholder="selecione"
                                :invalid="!origemSelected"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div class="column is-4">
                            <IconsSelect
                                :id="generateId(4)"
                                title="icone"
                                @changeIcon="changeIcon"
                                required
                                ref="iconeInput"
                                msg="msg-campo-obrigatorio"
                                :invalid="invalidIcon"
                                :iconClass="motivo.icone"
                                :icons="icones"
                                :disabled="cantEdit"
                            ></IconsSelect>
                        </div>
                        <div class="column is-4">
                            <color-picker
                                title="selecione-uma-cor"
                                :id="generateId(5)"
                                :color="motivo.cor"
                                ref="cpInput"
                                @colorpicked="colorpicked"
                                :disabled="cantEdit"
                            />
                        </div>
                        <div
                            class="column is-4"
                            v-show="isVisibleToSelectedOrigem(exclusionOrigensQtdeMinimaFoto)"
                        >
                            <v-input
                                :id="generateId(7)"
                                ref="qtdeMinimaFoto"
                                placeholder="placeholder-preencha"
                                v-model="motivo.qtdeminimafoto"
                                :useMask="true"
                                :vMask="['###']"
                                required
                                title="qtde-minima-fotos"
                                :msg="'msg-erro-numero-menor-que-0'"
                                :invalid="!motivo.qtdeminimafoto"
                                :disabled="cantEdit"
                            />
                        </div> 
                    </div>
                    <div class="form-columns-fit">
                        <div class="columns is-flex-wrap">
                            <div
                                class="column is-4"
                                v-show="isVisibleToSelectedOrigem(exclusionOrigensContato)"
                            >
                                <label>
                                    {{ $t("nome-do-contato") }}
                                    <b-icon
                                        icon="information"
                                        size="is-small"
                                        v-tippy 
                                        :title="$t(
                                            'tipo-recomendacao-tooltip-geral', 
                                            { n: $t('nome-do-contato') }
                                        )"
                                    />
                                </label>
                                <div class="group-buttons">
                                    <b-button
                                        class="expanded-buttons"
                                        :id="generateId(30)"
                                        @click="
                                            changeCheckHabilita('nomeContato')
                                        "
                                        :type="
                                            checks.nomeContato.habilita
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="!checks.nomeContato.habilita"
                                        :disabled="cantEdit"
                                    >
                                        <span>{{ $t("habilita") }}</span>
                                    </b-button>
                                    <b-button
                                        class="expanded-buttons"
                                        :id="generateId(40)"
                                        @click="
                                            changeCheckObriga('nomeContato')
                                        "
                                        :type="
                                            checks.nomeContato.obriga
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="!checks.nomeContato.obriga"
                                        :disabled="cantEdit"
                                    >
                                        <span>{{ $t("obriga") }}</span>
                                    </b-button>
                                </div>
                            </div>
                            <div class="column is-4">
                                <label>
                                    {{ $t("obs") }}
                                    <b-icon
                                        icon="information"
                                        size="is-small"
                                        v-tippy 
                                        :title="origemSelected && origemSelected.id ===
                                        'CONTA_CORRENTE_FLEX'
                                            ? $t(
                                                    'tipo-recomendacao-tooltip-conta-corrente',
                                                { n: $t('obs') }
                                            )
                                            : $t(
                                                    'tipo-recomendacao-tooltip-geral',
                                                { n: $t('obs') }
                                            )"
                                    />
                                </label>
                                <div class="group-buttons">
                                    <b-button
                                        class="expanded-buttons"
                                        :id="generateId(30)"
                                        :type="
                                            checks.obs.habilita
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="!checks.obs.habilita"
                                        @click="changeCheckHabilita('obs')"
                                        :disabled="cantEdit"
                                    >
                                        <span>{{ $t("habilita") }}</span>
                                    </b-button>
                                    <b-button
                                        class="expanded-buttons"
                                        :id="generateId(40)"
                                        :type="
                                            checks.obs.obriga
                                                ? 'is-primary'
                                                : ''
                                        "
                                        :outlined="!checks.obs.obriga"
                                        @click="changeCheckObriga('obs')"
                                        :disabled="cantEdit"
                                    >
                                        <span>{{ $t("obriga") }}</span>
                                    </b-button>
                                </div>
                            </div>
                            <div
                                class="column is-4 is-flex is-flex-column g-2"
                                v-if="
                                    origemSelected
                                        ? origemSelected.id === 'CONTA_CORRENTE_FLEX'
                                        : false
                                "
                            >
                                <label>
                                    {{ $t("inicio") }}
                                    <b-icon
                                        icon="information"
                                        size="is-small"
                                        v-tippy 
                                        :title="$t('tooltip-motivo-criacao')"
                                    />
                                </label>
                                <b-switch
                                    v-model="inicioBool"
                                    :disabled="false"
                                    size="is-medium"
                                >
                                </b-switch>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import motivoService from "@/services/agro/MotivoService";
import MotivoValidation from "@/services/validations/agro/MotivoValidation";
import ColorPicker from "@/components/shared/form/ColorPicker";
import IconsSelect from "@/components/shared/form/IconsSelect";

export default {
    components: {
        IconsSelect,
        ColorPicker,
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes("MOTIVO"),
            service: new motivoService(this.$http, this.$router),
            validation: new MotivoValidation(this.msgs),
            isLoading: false,
            isSaving: false,
            codigo: null,
            icones: [
                { pack: "fas", class: "feather-alt" },
                { pack: "fas", class: "bug" },
                { pack: "fas", class: "viruses" },
                { pack: "fas", class: "disease" },
                { pack: "fas", class: "snowflake" },
                { pack: "fas", class: "spa" },
                { pack: "fas", class: "wind" },
                { pack: "fas", class: "temperature-high" },
                { pack: "fas", class: "temperature-low" },
                { pack: "fas", class: "money-check-alt" },
                { pack: "fas", class: "exclamation-triangle" },
                { pack: "fas", class: "times" },
            ],
            invalidIcon: false,
            origemSelected: null,
            origemSelect: [],
            inicioBool: false,
            motivo: {
                idmotivo: null,
                descricao: null,
                icone: "",
                cor: "#D0CFCF",
                origem: null,
                qtdeminimafoto: null,
                inicio: 0,
                habilitaobrigacontato: 0,
                habilitaobrigaobservacao: 0,
            },
            editable: false,
            msgs: [],
            permissao: {},
            isUpdate: false,
            allowedCreate: false,
            allowedUpdate: false,
            checks: {
                obs: { habilita: false, obriga: false },
                nomeContato: { habilita: false, obriga: false },
            },
            cantEdit: true,
            exclusionOrigensQtdeMinimaFoto: [
                'CONTA_CORRENTE_FLEX', 
                'CANCELAR_PEDIDO', 
                'PEDIDO_AUTORIZACAO', 
                'ITEM_PEDIDO_AUTORIZACAO', 
                'EXCLUIR_PEDIDO', 
                'EXCLUIR_ITEMPEDIDO',
                'TIPO_PEDIDO',
                'CHECKIN'
            ],
            exclusionOrigensContato: [
                'CONTA_CORRENTE_FLEX',
                'EXCLUIR_ITEMPEDIDO',
                'PEDIDO_AUTORIZACAO',
                'ITEM_PEDIDO_AUTORIZACAO',
                'CHECKIN'
            ]
        };
    },

    created() {
        this.isUpdate =
            this.$route.params.id != null && this.$route.params.id != "new";

        if (this.$route.meta.contexto == "agro") {
            this.permissao = this.hasPermissionAccess(
                "agro",
                "agro-cadastros",
                "agro-motivo"
            );
        } else if (this.$route.meta.contexto == "despesas") {
            this.permissao = this.hasPermissionAccess(
                "despesas",
                "cadastros",
                "des-motivo"
            );
        } else if (this.$route.meta.contexto == "vendas") {
            this.permissao = this.hasPermissionAccess(
                "vendas",
                "financeiro",
                "ven-motivo"
            );
        }

        if (
            (!this.isUpdate && !this.permissao.create) ||
            (this.isUpdate && !this.permissao.read)
        ) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "motivo" },
            });
        } else {
            this.cantEdit =
                (!this.$route.params.id && !this.permissao.create) ||
                (this.$route.params.id && !this.permissao.update);

            if (this.$route.params.id) {
                this.carregarDados();
            } else {
                this.loadOrigem();
            }
        }
    },
    methods: {
        isVisibleToSelectedOrigem(exclusionOrigens) {
            if(!this.origemSelected) return true;
            
            const isInExclusionOrigem = exclusionOrigens.includes(this.origemSelected.id)

            return !isInExclusionOrigem;
        },
        loadOrigem() {
            // para carregar a listagem da origem no cadastro
            this.isLoading = true;
            this.service
                .findAllOrigens()
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `Erro com status ${r.status} ao realizar pesquisa por origens.`
                        );
                    } else {
                        this.origemSelect = r.content.map((i) => {
                            return { id: i, label: i };
                        });
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa por origens.`, e);
                })
                .finally(() => {
                    if (!this.isNull(this.motivo.origem)) {
                        this.origemSelected = this.origemSelect.filter((f) => {
                            return f.id == this.motivo.origem;
                        })[0];
                    }

                    this.isLoading = false;
                });
        },
        changeCheckHabilita(v) {
            this.checks[v].habilita = !this.checks[v].habilita;
            if (!this.checks[v].habilita) this.checks[v].obriga = false;
        },
        changeCheckObriga(v) {
            this.checks[v].obriga = !this.checks[v].obriga;
            if (this.checks[v].obriga) this.checks[v].habilita = true;
        },
        mapChecksToSave(v) {
            if (this.checks[v].obriga) {
                return 2;
            } else if (this.checks[v].habilita) {
                return 1;
            } else {
                return 0;
            }
        },
        changeIcon(icon) {
            this.motivo.icone = icon;
        },
        colorpicked(color) {
            this.motivo.cor = color;
        },
        carregarDados() {
            this.isLoading = true;

            this.service
                .find(this.$route.params.id)
                .then((body) => {
                    if (body.content) {
                        this.motivo = body.content;
                        this.origemSelected = this.motivo.origem;
                    } else {
                        this.$router.push({
                            name: `${$route.meta.abrev}-motivo-new`,
                        });
                    }
                })
                .finally(() => {
                    this.loadOrigem();

                    this.inicioBool = Boolean(this.motivo.inicio);

                    this.checks.obs.obriga =
                        this.motivo.habilitaobrigaobservacao == 2;
                    this.checks.obs.habilita =
                        this.motivo.habilitaobrigaobservacao > 0;

                    this.checks.nomeContato.obriga =
                        this.motivo.habilitaobrigacontato == 2;
                    this.checks.nomeContato.habilita =
                        this.motivo.habilitaobrigacontato > 0;

                    this.isLoading = false;
                });
        },
        saveMotivo() {
            this.isLoading = true;

            this.motivo.habilitaobrigacontato =
                this.mapChecksToSave("nomeContato");
            this.motivo.habilitaobrigaobservacao = this.mapChecksToSave("obs");
            this.motivo.origem =
                this.origemSelected != null ? this.origemSelected.id : null;
            this.invalidIcon = this.motivo.icone == "";
            this.motivo.inicio = Number(this.inicioBool);

            if (
                this.validation.validate(this.motivo, this.$refs) &&
                !this.invalidIcon
            ) {
                let tempMotivo = Object.assign({}, this.motivo);
                tempMotivo.idmotivo = this.$route.params.id
                    ? this.$route.params.id
                    : null;

                tempMotivo = this.mapTosave(tempMotivo, "origem", "icone");

                this.isSaving = true;
                this.service
                    .save(tempMotivo)
                    .then((body) => {
                        if (body.content) {
                            let msg = "msg-motivo-salva";
                            if (this.motivo.idmotivo) {
                                msg = "msg-motivo-edita";
                            }
                            this.$root.showMessage("success", msg, true);
                        } else {
                            if (this.$t(body.message)) {
                                this.$root.showMessage(
                                    "alert",
                                    body.message,
                                    true
                                );
                            } else {
                                this.$root.showMessage(
                                    "success",
                                    "motivo",
                                    true
                                );
                            }
                        }
                        this.isSaving = false;
                        if(!this.motivo.idmotivo){
                            this.redirectToPage(2);
                        }
                    })
                    .catch((e) => {
                        if (e.body.status == 409) {
                            this.$root.showMessage("alert", e.body.message);
                        } else {
                            this.$root.showMessage("error", "msg-erro-load");
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.isLoading = false;
                this.$root.showMessage(
                    "alert",
                    "msg-campos-obrigatorios",
                    true
                );
            }
        },
        redirectToPage(time) {
            let tempTela = null;
            let tempAba = null;
            if (this.$route.query.tela) {
                tempTela = "des-acerto-despesa-edit";

                if (this.$route.query.tela == 'prestacao-contas') {
                    tempAba = "geral";
                }else {
                    tempAba = "despesas";
                }

                setTimeout(() => {
                    this.$router.push({
                        name: tempTela,
                        params: { id: this.$route.query["id"] },
                        query: { abaSelecionada: tempAba },
                    });
                }, time * 1000);
            }else {
                this.redirectToList(time);
            }
        },
        redirectToList(time) {
            setTimeout(() => {
                this.$router.push({
                    name: `${this.$route.meta.abrev}-motivo-list`,
                });
            }, time * 1000);
        },
        generateId(numberId) {
            return this.$route.name + "-" + numberId;
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;
}

.g-2 {
    gap: 8px;
}
</style>